import { render } from "./AdminWerehouseView.vue?vue&type=template&id=486979cc"
import script from "./AdminWerehouseView.vue?vue&type=script&lang=js"
export * from "./AdminWerehouseView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__